import { render, staticRenderFns } from "./ParticipantTypeField.vue?vue&type=template&id=47546c18"
import script from "./ParticipantTypeField.vue?vue&type=script&lang=js"
export * from "./ParticipantTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports